import {
  POLICY_ALL,
  POLICY_PUT,
  POLICY_LOADING,
  POLICY_ERROR,
} from '../../actions/types';

const initialState = {
  productType: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case POLICY_LOADING:
      return { isLoading: true, isCompleted: true };
    case POLICY_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case POLICY_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case POLICY_PUT:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
